import { MissionData } from '../blocks/mission'
import template from './templates/RJS02.rbxl'
import thumbnail1 from './thumbnails/RJS02/Ball.png'
import thumbnail2 from './thumbnails/RJS02/LeftGoal.png'
import thumbnail3 from './thumbnails/RJS02/RightGoal.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ボール',
      thumbnail: thumbnail1,
    },
    {
      name: '②ひだりゴール',
      thumbnail: thumbnail2,
    },
    {
      name: '③みぎゴール',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
